// EntryBot frontend config
//
// API + redirect URLs are read from build-time env vars so the same code
// deploys to any environment. Create React App only exposes vars prefixed
// with REACT_APP_. Falls back to local dev defaults when unset.
//
//   REACT_APP_API_URL       -> base URL of the Laravel API (with trailing slash ok)
//   REACT_APP_REDIRECT_URL  -> public URL of this frontend (password reset / verify links)

const rawApiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Guarantee exactly one trailing slash (callers build `${BASE_URL}api/...`).
export const BASE_URL = rawApiUrl.replace(/\/+$/, '') + '/';

export const BASE_URL_REDIRECT =
    process.env.REACT_APP_REDIRECT_URL || 'http://localhost:3000';

// freecurrencyapi.com API key, used for exchange-rate lookups on Purchase/Sales
// invoice entry. Supplied as a build-time env var so the key is not baked into
// source. Falls back to empty — callers must guard against missing key.
export const FREECURRENCY_API_KEY =
    process.env.REACT_APP_FREECURRENCY_API_KEY || '';
